<template>
  <div class="pagina">
    <!-- Header -->
    <header class="header">
      <img src="/img/logo-preta.png" height="36" alt="Bike Registrada" />
    </header>

    <!-- Conteúdo principal -->
    <div class="conteudo">
      <div class="card-form">
        <h2 class="titulo">Registro realizado com sucesso!</h2>
        <p class="subtitulo">
          Agora é só baixar o aplicativo e continuar o processo do registro adicionando as
          informações da sua bicicleta de forma rápida e segura.
        </p>

        <!-- Ícone chave — criar senha -->
        <div v-if="!possuiSenha" class="info-row">
          <img src="/img/chave-senha.svg" width="44" class="info-icon" />
          <p class="info-texto">
            É essencial criar a senha para completar as informações do registro no aplicativo.
            Crie sua senha clicando no botão abaixo para continuar a contratação do seguro no
            App Bike Registrada.
          </p>
        </div>

        <!-- Ícone celular — baixar app -->
        <div v-if="!possuiSenha" class="info-row">
          <img src="/img/smartphone.svg" width="44" class="info-icon" />
          <p class="info-texto">
            Após criar a sua senha, baixe o App Bike Registrada e finalize registro!
          </p>
        </div>

        <!-- Ações -->
        <div class="rodape-acoes">
          <button v-if="!possuiSenha" class="btn-criar-senha" @click="showModalSenha = true">
            Criar senha de acesso agora
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.16699 9.99935H15.8337M15.8337 9.99935L10.0003 4.16602M15.8337 9.99935L10.0003 15.8327"
                stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button v-else class="btn-criar-senha" @click="redirectToAppStore">
            Baixar App Bike Registrada
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.16699 9.99935H15.8337M15.8337 9.99935L10.0003 4.16602M15.8337 9.99935L10.0003 15.8327"
                stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <a href="https://bikeregistrada.com.br/" class="link-home">
            Ir para a página inicial do site
          </a>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer">
      <span>Copyright © 2025 Bike Registrada Online LTDA.</span>
      <div class="footer-contatos">
        <span>Contatos:</span>
        <a href="https://wa.me/556135224521" target="_blank" rel="noopener">
          <i class="fab fa-whatsapp"></i> (61) 3522-4521
        </a>
        <a href="mailto:seguro@bikeregistrada.com.br">
          <i class="far fa-envelope"></i> seguro@bikeregistrada.com.br
        </a>
      </div>
    </footer>

    <ModalCriarSenha :show="showModalSenha" :seguro="{ emailCliente: email }" @hide="showModalSenha = false"
      @sucesso="showModalSenha = false; possuiSenha = true; showModalSucesso = true;" />

    <ModalSucessoCheckout :show="showModalSucesso"
      subtitle="Baixe o App Bike Registrada, faça o login e finalize o registro de sua bike."
      @hide="showModalSucesso = false" />
  </div>
</template>

<script>
import axios from "axios";
import config from "../config";
import captureError from "../helpers/captureError";

export default {
  components: {
    ModalCriarSenha: () => import("../components/Modal/ModalCriarSenha.vue"),
    ModalSucessoCheckout: () => import("../components/Modal/ModalSucessoCheckout.vue"),
  },
  data() {
    return {
      email: null,
      possuiSenha: false,
      showModalSenha: false,
      showModalSucesso: false,
    };
  },
  async created() {
    this.email = this.$route.query.email || null;
    if (this.email) {
      await this.verificarSenha();
    }
  },
  methods: {
    async verificarSenha() {
      try {
        const response = await axios.get(`${config.API_URLV2}/cliente/VerificarPossuiSenha`, {
          params: { email: this.email },
        });
        this.possuiSenha = response.data === true || response.data?.possuiSenha === true;
      } catch (error) {
        captureError(error);
        this.possuiSenha = true; // em caso de erro, não exibe o fluxo de senha
      }
    },
    redirectIos() {
      window.open('https://apps.apple.com/br/app/bike-registrada/id1661678422', '_blank');
    },
    redirectPlay() {
      window.open('https://play.google.com/store/apps/details?id=br.com.seguro.bikeregistrada', '_blank');
    },
    redirectToAppStore() {
      const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
      if (isIos) {
        this.redirectIos();
      } else {
        this.redirectPlay();
      }
    },
  },
};

</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

/* ── Página ── */
.pagina {
  min-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f9f9f9;
  background-image: url(/img/bike-mundo.svg);
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 30%;
  font-family: Inter, sans-serif;
  display: flex;
  flex-direction: column;
}

/* ── Header ── */
.header {
  padding: 16px 32px;
  padding-top: calc(16px + env(safe-area-inset-top));
  background: #f9f9f9;
  display: flex;
  align-items: center;
}

/* ── Conteúdo ── */
.conteudo {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 24px;
}

.card-form {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  padding: 40px 48px;
  width: 100%;
  max-width: 652px;
}

.titulo {
  font-size: 22px;
  font-weight: 700;
  color: #1a3c6e;
  margin-bottom: 12px;
}

.subtitulo {
  font-size: 15px;
  color: #6f6c8f;
  line-height: 1.6;
  margin-bottom: 28px;
}

/* ── Linhas de informação ── */
.info-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.info-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.info-texto {
  font-size: 15px;
  color: #6f6c8f;
  line-height: 1.6;
  margin: 0;
}

/* ── Rodapé do card ── */
.rodape-acoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.btn-criar-senha {
  background-color: #4fa935;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-criar-senha:hover {
  background-color: #3a7d22;
}

.link-home {
  color: #4fa935;
  font-size: 14px;
  text-decoration: underline;
  white-space: nowrap;
}

.link-home:hover {
  color: #3a7d22;
}

/* ── Footer ── */
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 32px;
  font-size: 14px;
  color: #64748B;
}

.footer-contatos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-contatos a {
  color: #4FA935;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
}

.footer-contatos a:hover {
  text-decoration: underline;
}

/* ── Responsivo ── */
@media (max-width: 600px) {
  .link-home {
    text-align: center;
  }

  .pagina {
    background-size: 75%;
  }

  .card-form {
    padding: 28px 20px;
  }

  .rodape-acoes {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-criar-senha {
    width: 100%;
    text-align: center;
  }

  .footer {
    font-size: 10px;
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-contatos {
    gap: 12px;
    flex-wrap: wrap;
  }

  .footer-contatos a {
    white-space: nowrap;
  }

  .header {
    background: #fff;
    border-bottom: 1px solid #E2E8F0;
  }
}
</style>
